import React from 'react';
import { render } from 'react-dom';

import ConfigContextCreator from '@eika-infrastruktur/config-provider';

const getContainer = (container: HTMLScriptElement, namespace: string): Element => {
    const parent = container.parentNode || document;
    const existing = parent.querySelector(`[data-react-component~="${namespace}"]`);
    if (existing) {
        return existing;
    }

    const reactContainer = document.createElement('div');
    reactContainer.setAttribute('data-react-component', namespace);
    parent.insertBefore(reactContainer, container);

    return reactContainer;
};

interface ContainerTagProps {
    config: object;
}

export default (namespace: string, ContainerTag: React.FunctionComponent<ContainerTagProps>, defaultConfig = {}) => {
    const appContainers = document.querySelectorAll(`[data-react~="${namespace}"]`);

    [].forEach.call(appContainers, (container: HTMLScriptElement) => {
        const configText = container.innerText;
        const config = configText ? JSON.parse(configText) : {};

        const reactContainer = getContainer(container, namespace);
        const ConfigContext = ConfigContextCreator(defaultConfig);
        render(
            <ConfigContext state={config}>
                <ContainerTag config={config} />
            </ConfigContext>,
            reactContainer
        );
    });
};
